import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
export default {
  name: 'exhibitionitemv2',
  data() {
    return {};
  },
  props: ['exhibitions', 'formData', 'language', 'special', 'childList'],
  //special 是否定制
  // childList 子级列表
  methods: {
    getType(type) {
      let texts = {
        '常设展览': 'permanent',
        '临时展览': 'temporary',
        '总馆介绍': 'central',
        '分馆介绍': 'branch'
      };
      return texts[type];
    },
    showExhitonList(item) {
      let now = new Date();
      now = this.getDate(now);
      let flag = now >= this.getDate(item.exhibBegin) && now <= this.getDate(item.exhibEnd) || !item.exhibEnd || !item.exhibBegin;
      flag ? this.$router.push(`/${this.$route.query.fid == 152288 && this.childList.find(c => {
        return c.parentExhibitonName == item.exhibName;
      }) ? 'childExhibitionsv2' : 'audiosv2'}?fid=${this.formData.fid}&exhibCode=${item.code}${!this.language ? '&language=en' : ''}&formId=${this.$route.query.formId}`) : alert('暂不在开放时间');
    },
    getDate(date) {
      return Date.parse(date);
    },
    getName(item) {
      return this.language ? item.exhibName : item.en_name;
    },
    getAddress(item) {
      let address = item.exhibitionLocation !== '' ? item.exhibitionLocation : '';
      let en_address = item.en_location !== '' ? item.en_location : '';
      return this.language ? address : en_address;
    }
  },
  created() {},
  computed: {}
};